import OrderService from "@/app/services/OrderService.js"
import { types } from "@/app/types/types";

const state =
{
	[types.STATE_ORDERS]: []
};

const getters =
{
	[types.GET_ORDERS]: (state) =>
	{
		return state[types.STATE_ORDERS]
	},

	[types.GET_ORDER]: (state) => id =>
	{
		var orders = state[types.STATE_ORDERS];

		for (const order of orders)
		{
			if (order.id == id)
				return order;
		}

		return null;
	}
};

const mutations =
{
	[types.MUTATE_LOAD_ORDERS]: (state, payload) =>
	{
		// TODO: Do paging here
		state[types.STATE_ORDERS] = payload
	},

	[types.MUTATE_ADD_ORDER]: (state, payload) =>
	{
		state[types.STATE_ORDERS].push(payload);
	},

	[types.MUTATE_UPDATE_ORDER]: (state, payload) =>
	{
		//let index = state[types.STATE_ORDERS].findIndex(order => order.id == payload.id)
		//state[types.STATE_ORDERS].splice(index, 1, payload)
		let order = state[types.STATE_ORDERS].find((order) => { return order.id == payload.id });

		if (order)
		{
			order = payload
		}
	},

	[types.MUTATE_DELETE_ORDER]: (state, payload) =>
	{
		//let index = state[types.STATE_ORDERS].findIndex(order => order.id == payload.id)
		//state[types.STATE_ORDERS].splice(index, 1)
		state[types.STATE_ORDERS] = state[types.STATE_ORDERS].filter((order) => { return order.id !== payload });
	}
};

const actions =
{
	[types.ACTION_GET_ORDERS]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_ORDERS, payload: payload })

		return OrderService.getOrders(payload).then(response =>
		{
			commit(types.MUTATE_LOAD_ORDERS, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_ORDERS, message: error, payload: payload });
			return error.response
		});
	},

	[types.ACTION_GET_ORDER]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_ORDER, payload: payload })

		return OrderService.getOrder(payload).then(response =>
		{
			commit(types.MUTATE_UPDATE_ORDER, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_ORDER, message: error });
			return error.response
		});
	},

	[types.ACTION_ADD_ORDER]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_ADD_ORDER, payload: payload })

		return OrderService.addOrder(payload).then(response =>
		{
			commit(types.MUTATE_ADD_ORDER, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_ADD_ORDER, message: error.message, payload: payload });
			return error.response
		});
	},

	[types.ACTION_UPDATE_ORDER]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_UPDATE_ORDER, payload: payload })

		return OrderService.updateOrder(payload).then(response =>
		{
			commit(types.MUTATE_UPDATE_ORDER, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_UPDATE_ORDER, message: error.message, payload: payload });
			return error.response
		});
	},

	[types.ACTION_DELETE_ORDER]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_DELETE_ORDER, payload: payload })

		return OrderService.deleteOrder(payload).then(response =>
		{
			commit(types.MUTATE_DELETE_ORDER, payload);
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_DELETE_ORDER, message: error.message, payload: payload });
			return error.response
		});
	},

	[types.ACTION_DOWNLOAD_ORDERING_PDF_PERSON]: ({ commit, rootState }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_DOWNLOAD_ORDERING_PDF_PERSON, payload: payload })

		//var token = rootState.users[types.STATE_USER].token
		return OrderService.getOrderingPDF(payload.personid, payload.agreementid, payload.filename).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_DOWNLOAD_ORDERING_PDF_PERSON, message: error.message, payload: payload });
			return error.response
		});
	},

	[types.ACTION_GENERATE_ORDERING_PDF_AGREEMENT]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GENERATE_ORDERING_PDF_AGREEMENT, payload: payload })

		return OrderService.generateOrderingPDF(payload.agreementid).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GENERATE_ORDERING_PDF_AGREEMENT, message: error.message, payload: payload });
			return error.response
		});
	},

	[types.ACTION_GENERATE_ORDERING_PDF_ALLPERSONGROUPS]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GENERATE_ORDERING_PDF_ALLPERSONGROUPS, payload: payload })

		return OrderService.generateOrderingPDF(payload.agreementid, -1).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GENERATE_ORDERING_PDF_ALLPERSONGROUPS, message: error.message, payload: payload });
			return error.response
		});
	},

	[types.ACTION_GENERATE_ORDERING_PDF_PERSONGROUP]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GENERATE_ORDERING_PDF_PERSONGROUP, payload: payload })

		return OrderService.generateOrderingPDF(payload.agreementid, payload.persongroupid).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GENERATE_ORDERING_PDF_PERSONGROUP, message: error.message, payload: payload });
			return error.response
		});
	},

	[types.ACTION_GENERATE_ORDERING_PDF_PERSON]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GENERATE_ORDERING_PDF_PERSON, payload: payload })

		return OrderService.generateOrderingPDF(payload.agreementid, 0, payload.personid).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GENERATE_ORDERING_PDF_PERSON, message: error.message, payload: payload });
			return error.response
		});
	},

	[types.ACTION_GET_GENERATED_FILES]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_GENERATED_FILES, payload: payload })

		return OrderService.getGeneratedFiles(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_GENERATED_FILES, message: error.message, payload: payload });
			return error.response
		});
	},

	[types.ACTION_DOWNLOAD_GENERATED_FILE]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_DOWNLOAD_GENERATED_FILE, payload: payload })

		return OrderService.downloadGeneratedFile(payload.fileid, payload.filename).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_DOWNLOAD_GENERATED_FILE, message: error.message, payload: payload });
			return error.response
		});
	},

	[types.ACTION_GET_PERSON_ORDERINFORMATION]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_PERSON_ORDERINFORMATION, payload: payload })

		return OrderService.getPersonOrderInformation(payload.customerid, payload.agreementid, payload.personid, payload.persongroupid, payload.orderid).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_PERSON_ORDERINFORMATION, message: error.message });
			return error.response
		});
	},

	[types.ACTION_GET_ORDERS_BY_PERSONGROUP]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_ORDERS_BY_PERSONGROUP, payload: payload })

		return OrderService.getOrdersByPersonGroup(payload.customerid, payload.persongroupid).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_ORDERS_BY_PERSONGROUP, message: error.message });
			return error.response
		});
	},

	[types.ACTION_SEND_WEBSHOPLINK_TO_CLIENT]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_SEND_WEBSHOPLINK_TO_CLIENT, payload: payload })

		return OrderService.sendWebshopLinkToClient(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_SEND_WEBSHOPLINK_TO_CLIENT, message: error.message });
			return error.response
		});
	},

	[types.ACTION_SEND_NEW_WEBSHOPCODE_TO_CLIENT]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_SEND_NEW_WEBSHOPCODE_TO_CLIENT, payload: payload })

		return OrderService.sendNewWebshopCodeToClient(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_SEND_NEW_WEBSHOPCODE_TO_CLIENT, message: error.message });
			return error.response
		});
	},

	[types.ACTION_SEND_WEBSHOPLINKS_TO_CLIENTS]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_SEND_WEBSHOPLINKS_TO_CLIENTS, payload: payload })

		return OrderService.sendWebshopLinksToClients(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_SEND_WEBSHOPLINKS_TO_CLIENTS, message: error.message });
			return error.response
		});
	},

	[types.ACTION_SEND_RECEIPT_TO_CLIENT]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_SEND_RECEIPT_TO_CLIENT, payload: payload })

		return OrderService.sendReceiptToClient(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_SEND_RECEIPT_TO_CLIENT, message: error.message });
			return error.response
		});
	},

	[types.ACTION_SEND_PAYMENTLINK_TO_CLIENT]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_SEND_PAYMENTLINK_TO_CLIENT, payload: payload })

		return OrderService.sendPaymentlinkToClient(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_SEND_PAYMENTLINK_TO_CLIENT, message: error.message })
			return error.response
		})
	},

	[types.ACTION_SEND_PAYMENTREMINDER_TO_CLIENT]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_SEND_PAYMENTREMINDER_TO_CLIENT, payload: payload })

		return OrderService.sendPaymentReminderToClient(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_SEND_PAYMENTREMINDER_TO_CLIENT, message: error.message })
			return error.response
		})
	},

	[types.ACTION_FIND_ORDERS]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_FIND_ORDERS, payload: payload })

		return OrderService.findOrders(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_FIND_ORDERS, message: error.message });
			return error.response
		});
	},

	[types.ACTION_CREATE_ORDERCOPY]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_CREATE_ORDERCOPY, payload: payload })

		return OrderService.createOrderCopy(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_CREATE_ORDERCOPY, message: error.message })
			return error.response
		})
	}
}

export default
	{
		state,
		mutations,
		actions,
		getters
	}
